import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=42db44a0&lang=pug&"
import script from "./ui-button.vue?vue&type=script&lang=js&"
export * from "./ui-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42db44a0')) {
      api.createRecord('42db44a0', component.options)
    } else {
      api.reload('42db44a0', component.options)
    }
    module.hot.accept("./ui-button.vue?vue&type=template&id=42db44a0&lang=pug&", function () {
      api.rerender('42db44a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-button.vue"
export default component.exports